/**
 * @class Dialog
 */
export default class Dialog {
    /**
     * @param   {Number}    id
     * @param   {String}    type
     * @param   {String}    text
     * @param   {Number}    message
     * @param   {String}    messageCode
     * @param   {Number}    icon
     * @param   {Array}     buttons
     * @param   {Array}     params
     * @param   {Object}    meta
     */
    constructor(id, type, text, message, messageCode, icon, buttons, params, meta) {
        this._id = id;
        this._type = type;
        this._statusText = text;
        this._text = text;
        this._message = message;
        this._messageCode = messageCode;
        this._icon = icon;
        this._buttons = buttons;
        this._params = params;
        this._meta = meta;
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} statusText
     */
    set statusText(statusText) {
        this._statusText = statusText;
    }

    /**
     * @return {String}
     */
    get statusText() {
        return this._statusText;
    }

    /**
     * @param {String} text
     */
    set text(text) {
        this._text = text;
    }

    /**
     * @return {String}
     */
    get text() {
        return this._text;
    }

    /**
     * @param {Number} message
     */
    set message(message) {
        this._message = message;
    }

    /**
     * @return {Number}
     */
    get message() {
        return this._message;
    }

    /**
     * @param {String}  messageCode
     */
    set messageCode(messageCode) {
        this._messageCode = messageCode;
    }

    /**
     * @return {String}
     */
    get messageCode() {
        return this._messageCode;
    }

    /**
     * @param {Number} icon
     */
    set icon(icon) {
        this._icon = icon;
    }

    /**
     * @return {Number}
     */
    get icon() {
        return this._icon;
    }

    /**
     * @param {Array} buttons
     */
    set buttons(buttons) {
        this._buttons = buttons;
    }

    /**
     * @return {Array}
     */
    get buttons() {
        return this._buttons;
    }

    /**
     * @param {Array} params
     */
    set params(params) {
        this._params = params;
    }

    /**
     * @return {Array}
     */
    get params() {
        return this._params;
    }

    /**
     * @param {Object} meta
     */
    set meta(meta) {
        this._meta = meta;
    }

    /**
     * @return {Object}
     */
    get meta() {
        return this._meta;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Dialog (" + this._id + ")";
    }

    /**
     * Clones dialog object.
     *
     * @return  {Object}
     */
    clone = () => {
        return new Dialog(
            this._id,
            this._type,
            this._text,
            this._message,
            this._messageCode,
            this._icon,
            this._buttons,
            this._params,
            this._meta
        );
    };

    /**
     * Clones dialog object and updates text and statusText property.
     *
     * @param   {String}    text
     * @return  {Object}
     */
    updateText = (text) => {
        let dialog = this.clone();
        dialog.text = text;

        return dialog;
    };

    /**
     * Abstract function for later immplementation.
     *
     * @param   {Number | null} percentage
     * @param   {Number | null} timeLeft
     * @param   {Array}         progressItems
     * @return  {Object}
     */
    updateProgressItems = () => {
        return this;
    };
}
